import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function RegisterPage() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: '', email: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    setError(''); setLoading(true);
    const data = await register(form.name, form.email, form.password);
    setLoading(false);
    if (data.success) navigate('/');
    else setError(data.error || 'Registration failed');
  };

  return (
    <div className="auth-page">
      <div className="auth-box">
        <div className="auth-logo">
          <div className="logo-icon" style={{ width: 52, height: 52, background: 'linear-gradient(135deg,#ff6b00,#ff8c3a)', borderRadius: 14, display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', fontWeight: 800, fontSize: 24, margin: '0 auto 12px' }}>φ</div>
          <div style={{ fontWeight: 700, fontSize: 20, color: 'var(--secondary)' }}>PhysicsAI Tutor</div>
        </div>
        <h2>Get Started Free</h2>
        <p>10 free queries/month. No credit card needed.</p>

        {error && <div className="alert alert-error">{error}</div>}

        <div className="form-group">
          <label className="form-label">Full Name</label>
          <input className="form-input" type="text" placeholder="Your full name" value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} />
        </div>
        <div className="form-group">
          <label className="form-label">Email Address</label>
          <input className="form-input" type="email" placeholder="you@example.com" value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} />
        </div>
        <div className="form-group">
          <label className="form-label">Password</label>
          <input className="form-input" type="password" placeholder="Min. 8 characters" value={form.password} onChange={e => setForm({ ...form, password: e.target.value })} onKeyDown={e => e.key === 'Enter' && handleSubmit()} />
        </div>
        <button className="btn-primary" style={{ width: '100%', justifyContent: 'center', padding: '13px', fontSize: 15, borderRadius: 10, marginTop: 8 }} onClick={handleSubmit} disabled={loading}>
          {loading ? 'Creating account...' : 'Create Free Account →'}
        </button>

        <div className="auth-footer" style={{ marginTop: 24 }}>
          Already have an account? <Link to="/login">Sign in</Link>
        </div>
        <p style={{ fontSize: 12, color: 'var(--text-muted)', textAlign: 'center', marginTop: 12 }}>
          By signing up, you agree to our <a href="#" style={{ color: 'var(--primary)' }}>Terms</a> and <a href="#" style={{ color: 'var(--primary)' }}>Privacy Policy</a>
        </p>
      </div>
    </div>
  );
}
